import React from 'react';
import styles from './styles.module.scss';

const Spinner = () => {
  return (
    <div className={styles.ldsCss}>
      <div className={styles.ldsDoubleRing}>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Spinner;
